import React, { useEffect } from "react";
import "../../styles/Home-module.css";
import { linkPathIDCard } from "../../share/helper";
import { getCurrentUser } from "../../share/getProfile";

export default class ComponentToPrint extends React.Component {
  render() {
    const profileData = getCurrentUser();
    const {
      name,
      gender,
      idnumber,
      position_p,
      phone_p,
      date_request_p,
      date_start_p,
      date_end_p,
      date_work_p,
      reason_p,
      Num_using,
      Num_Remaining,
      Num_Request,
      Num_using_short,
      Num_Remaining_short,
      Num_Request_short,
      Num_Request_Maternity,
      Num_using_Maternity,
      Num_Remaining_Maternity,
      Num_Request_Medical,
      Num_using_Medical,
      Num_Remaining_Medical,
      Num_using_person,
      Num_Remaining_person,
      Num_Request_person,
      template_org,
      count_day_request,
      count_day_request_en,
      Org_ImagePath,
      leavesetting,
    } = this.props;
    const logoname =
      Org_ImagePath ||
      "https://cdn.vectorstock.com/i/500p/38/25/registered-trademark-logo-icon-copyright-mark-vector-36613825.jpg";
    const cleaned_orgname = profileData.org_name_kh
      .replace(profileData.province_name, "")
      .trim();
    const cleaned_orgname_cover = profileData.org_cover_by
      .replace(profileData.province_name, "")
      .trim();

    const htmlContent = `
  <!DOCTYPE html>
<html lang="en">
  <style>
  @import url('https://fonts.googleapis.com/css2?family=Content&family=Moul&display=swap');
 body {
  font-family: 'Content';
  line-height: 2em; /* Consistent spacing for print */
}

p, td, span {
  line-height: 2em;
}

p {
  margin-top: 0pt;
  margin-bottom: 0pt;
  text-align: center;
  font-size: 10.5pt;
}

 </style>
<body> 
<div class="headerstyle">
<img src=${logoname !== undefined
        ? logoname
        : "https://cdn.vectorstock.com/i/500p/38/25/registered-trademark-logo-icon-copyright-mark-vector-36613825.jpg"
      }

 alt="Logo" width="90" height="90" style=" margin-left: 20px; top: 53px; " />
 
 <p style="text-align: center; font-family: 'Moul', cursive; font-size: 12pt;">ព្រះរាជាណាចក្រកម្ពុជា</p>
<p style="text-align: center; font-family: 'Moul', cursive; font-size: 12pt;">ជាតិ សាសនា ព្រះមហាក្សត្រ</p>
<div style="text-align: center;">
  <img src="/images/border_line.png" alt="border_line" style="width: 120px; margin-top: -5px; position: static;" />
</div>
<p style="text-align: left;">
<br/><br/>
<p style="text-align: left; margin-top: 10px; font-family: 'Moul', cursive;">
  ${profileData.org_type > 4
        ? ""
        : `រដ្ឋបាលខេត្ត${profileData.province_name}`
      }
</p>
<p style="text-align: left; font-family: 'Moul', cursive; ">
  ${profileData.org_type > 1
        ? profileData.org_cover_by
        : `រដ្ឋបាលខេត្ត${profileData.province_name}`
      }
</p>

<p style="text-align: left; font-family: 'Moul', cursive; ">${profileData.org_name_kh}</p>
<span style="text-align: left; font-family: 'Moul';    font-size:9pt; ">លេខ ..................... </span>
<p style="text-align: center; font-family: 'Moul', cursive;">សំណើសុំច្បាប់ និងការអនុញ្ញាតច្បាប់ឈប់សម្រាកគ្រប់ប្រភេទ</p>
<p style="text-align: center; font-family: 'Moul', cursive;">របស់មន្រ្ដីរាជការស៊ីវិល នៃ ព្រះរាជាណាចក្រកម្ពុជា</p>
 <br/>
</div>
<p style="text-align: left;"> <strong>យោង៖</strong> &nbsp;អនុក្រិត្យលេខលេខ២១៧អនក្រ.បក.ចុះថ្ងៃទី ០២ ខែឧសភា ឆ្នាំ២០១៣ស្ដីពី របបការសុំច្បាប់ និងការអនុញ្ញាត</p>
<p style="text-align: left; margin-left: 40px;">&nbsp;ច្បាប់គ្រប់ប្រភេទ របស់មន្រ្ដីរាជការស៊ីវិល នៃព្រះរាជាណាក្រកម្ពុជា ។</p>
  
<p style="text-align: left;"><strong>១.គោត្តនាម និងនាម</strong>៖&nbsp;<strong><em>${name} .&nbsp;</em></strong> ភេទ៖&nbsp;<strong><em> ${gender}</em></strong>&nbsp; អត្តលេខ៖...${idnumber}....មុខតំណែង៖&nbsp;<strong><em>  ${position_p}</em></strong></p>
<p style="text-align: left; margin-left: 40px;">អង្គភាព៖&nbsp;<strong><em>${profileData.org_name_kh
      }&nbsp;</em></strong>&nbsp;ទូរស័ព្ទ ៖&nbsp;<strong><em> ${phone_p}</em></strong></p>



<p style="text-align: left;"><strong>២. ប្រភេទនៃច្បាប់ឈប់សម្រាកដែលត្រូវស្នើសុំ៖</strong></p>
 <p style="text-align: left; margin-left: 40px;">
  <input ${Num_Request > 0 ? "checked" : ""
      } name="cehck1" type="checkbox"> ឈប់ប្រចាំឆ្នាំ&nbsp;&nbsp;
  <input ${Num_Request_short > 0 ? "checked" : ""
      } name="cehck1" type="checkbox"> ឈប់រយៈពេលខ្លី&nbsp;&nbsp;&nbsp;
  <input ${Num_Request_Maternity > 0 ? "checked" : ""
      } name="cehck1" type="checkbox"> ឈប់សម្រាកលំហែមាតុភាព
</p>
<p style="text-align: left; margin-left: 40px;">
  <input ${Num_Request_Medical > 0 ? "checked" : ""
      } name="cehck1" type="checkbox"> ឈប់សម្រាកព្យាបាលជម្ងឺ&nbsp;
  <input ${Num_Request_person > 0 ? "checked" : ""
      } name="cehck1" type="checkbox"> ឈប់សម្រាកដោយមានភារៈកិច្ចផ្ទាល់ខ្លួន
</p>


<p style="text-align: left;"><strong>៣. ចំនួនថ្ងៃស្នើសុំឈប់សម្រាកកាលបរិច្ឆេទ នៃការចាប់ផ្ដើមឈប់និងការបរិច្ឆេទនៃការចូលបម្រើការងារវិញ&nbsp;</strong>






</p>
<p style="text-align: left; margin-left: 40px;">- ចំនួនថ្ងៃស្នើសុំឈប់ : ...${count_day_request}...</p>
<p style="text-align: left; margin-left: 40px;">- ថ្ងៃ ខែ ឆ្នាំ ចាប់ផ្ដើមឈប់:..${date_start_p}...ដល់ ថ្ងៃទី ៖...${date_end_p}...</p>
<p style="text-align: left; margin-left: 40px;">- ថ្ងៃ ខែ ឆ្នាំ ចូលបម្រើការងារវិញ:...${date_work_p}...</p>






<p style="text-align: left;"><strong>៤. គោលបំណង៖</strong>...${reason_p}..............................................</p>
<table style="height: 104px; width: 807px;" cellspacing="0" cellpadding="0">
    <tbody>
        <tr style="height: 31px;">
                 <td style="height: 31px; width: ${count_day_request_en > 3 && profileData.org_type > 1
        ? "300px"
        : "0%"
      } ;  text-align: center;">

                 
 ${count_day_request_en > 3 && profileData.org_type > 1
        ? `
<div>
  <br/>
    
    <p style="text-align: left; margin-left: 40px;">បានឃើញ និង.....................</p>
 
</div>
      
      <p>ខេត្ត${profileData.province_name
        } ថ្ងៃទី......ខែ...........ឆ្នាំ ២០២....</p>
      <p>
        &nbsp;
        <span style="font-family: 'Content';">
          ${profileData.org_type > 1 ? `&nbsp;ប្រធាន${cleaned_orgname}` : ""}
        </span>
       
      </p><br/>
    `
        : ""
      }

</td>
         <td style="height: 31px; width: ${count_day_request_en > 3 && profileData.org_type > 1
        ? "250px"
        : "600px"
      } ; text-align: center;">
 ${leavesetting === 0
        ? `
      <p>បានឃើញ និង.................</p>
      <p>ខេត្ត${profileData.province_name
        } ថ្ងៃទី......ខែ..........ឆ្នាំ ២០២....</p>
      <p>
        &nbsp;
        <span style="font-family: 'Moul';">
          ${profileData.org_type === 3
          ? "ប្រធាន បច្ចេកទេស/ ផ្នែក ............. "
          : "ប្រធានផ្នែករដ្ឋបាល​ និងបុគ្គលិក"
        }
        </span>
       
      </p>
    `
        : ""
      }

</td>

            <td style="height: 31px; width:${count_day_request_en > 3 && profileData.org_type > 1
        ? "250px"
        : "400px"
      }; text-align: center;">
                <p >&nbsp;ខេត្ត${profileData.province_name}   ${date_request_p}
                <p style="  font-family: 'Moul';">&nbsp;ហត្ថលេខាអ្នកស្នើសុំ</p>
                <p>&nbsp;<br></p>
                <p>&nbsp;<br></p>
                <p style=" margin-left: 40px;"><strong>${name}</strong></p>
            </td>
        </tr>
    </tbody>
</table>
<p><br></p>
  <p><br></p>
<p style="text-align: left;">&nbsp;<strong>៥. ប្រធានការិយាល័យរដ្ឋបាលបុគ្គលិកដើម្បីជ្រាបជាពត៍មាន និងផ្ទៀងផ្ទាត់&nbsp;</strong></p>
<table style="height: 27px; width: 100%; border-collapse: collapse; border: 1px solid black; ">
    <tbody>
        <tr style="height: 4.875px; border: 1px solid black;">
            <td style="height: 4.875px; width: 94px; text-align: center; border: 1px solid black;">
                <p><strong>ការពណ៍នា</strong></p>
            </td>
            <td style="height: 4.875px; width: 107px; text-align: center; border: 1px solid black;">
                <p><strong>ឈប់ប្រចាំឆ្នាំ</strong></p>
                <p><strong>(១៥ថ្ងៃ)</strong></p>
            </td>
            <td style="height: 4.875px; width: 95px; text-align: center; border: 1px solid black;">
                <p><strong>ឈប់រយៈពេលខ្លី</strong></p>
                <p><strong>(១៥ថ្ងៃ)</strong></p>
            </td>
            <td style="height: 4.875px; width: 135px; text-align: center; border: 1px solid black;">
                <p><strong>ឈប់សម្រាកលំហែ</strong></p>
                <p><strong>មាតុភាព( ៩០ថ្ងៃ )</strong></p>
            </td>
            <td style="height: 4.875px; width: 201px; text-align: center; border: 1px solid black;">
                <p><strong>ឈប់សម្រាកព្យាបាលជម្ងឺ</strong></p>
                <p><strong> ១២ខែ/ពេលបម្រើការងារ</strong></p>
                <p><strong>( ជាមន្រ្ដីរាជការ )</strong></p>
            </td>
            <td style="height: 4.875px; width: 170.133px; text-align: center; border: 1px solid black;">
                <p><strong>ឈប់សម្រាកដោយមានកិច្ច</strong></p>
                <p><strong>ការផ្តាល់ខ្លួន(៩០ថ្ងៃ)ពេលបម្រើការងារ ( មន្រ្ដីរាជការ )</strong></p>
            </td>
        </tr>
        <tr style="height: 27px; border: 1px solid black;">
            <td style="height: 27px; width: 94px; border: 1px solid black; padding: 5px;">ចំនួននៅសល់</td>
      <td style="height: 9px; width: 135px; text-align: center; border: 1px solid black;">${Num_Remaining > 0 ? Num_Remaining : ""
      }</td>
       <td style="height: 9px; width: 135px; text-align: center; border: 1px solid black;">${Num_Remaining_short > 0 ? Num_Remaining_short : ""
      }</td>
              
      <td style="height: 16px; width: 135px; text-align: center; border: 1px solid black;"> 
      ${Num_Remaining_Maternity > 0 ? Num_Remaining_Maternity : ""}</td>
            <td style="height: 16px; width: 201px; text-align: center; border: 1px solid black;">${Num_Remaining_Medical > 0 ? Num_Remaining_Medical : ""
      }</td>
            <td style="height: 16px; width: 170.133px; text-align: center; border: 1px solid black;">${Num_Remaining_person > 0 ? Num_Remaining_person : ""
      }</td>
     </tr>
        <tr style="height: 9px; border: 1px solid black;">
            <td style="height: 9px; width: 94px; border: 1px solid black; padding: 5px;">ចំនួនស្នើសុំ</td>
           <td style="height: 9px; width: 135px; text-align: center; border: 1px solid black;">${Num_Request > 0 ? Num_Request : ""
      }</td>
           <td style="height: 9px; width: 135px; text-align: center; border: 1px solid black;">${Num_Request_short > 0 ? Num_Request_short : ""
      }</td>
          
           <td style="height: 9px; width: 135px; text-align: center; border: 1px solid black;">${Num_Request_Maternity > 0 ? Num_Request_Maternity : ""
      }</td>
            <td style="height: 9px; width: 201px; text-align: center; border: 1px solid black;">${Num_Request_Medical > 0 ? Num_Request_Medical : ""
      }</td>
            <td style="height: 9px; width: 170.133px; text-align: center; border: 1px solid black;">${Num_Request_person > 0 ? Num_Request_person : ""
      }</td>
        </tr>
        <tr style="height: 16px; border: 1px solid black;">
            <td style="height: 16px; width: 94px; border: 1px solid black;padding: 5px;">ចំនួនសរុបប្រើ</td>
           <td style="height: 16px; width: 135px; text-align: center; border: 1px solid black;">${Num_using > 0 ? Num_using : ""
      }</td>      
            <td style="height: 16px; width: 135px; text-align: center; border: 1px solid black;">${Num_using_short > 0 ? Num_using_short : ""
      }</td>    
             <td style="height: 16px; width: 135px; text-align: center; border: 1px solid black;">${Num_using_Maternity > 0 ? Num_using_Maternity : ""
      }</td>
            <td style="height: 16px; width: 201px; text-align: center; border: 1px solid black;">${Num_using_Medical > 0 ? Num_using_Medical : ""
      }</td>
            <td style="height: 16px; width: 170.133px; text-align: center; border: 1px solid black;">${Num_using_person > 0 ? Num_using_person : ""
      }</td>
        </tr>
    </tbody>
</table>

<p style="text-align: left;">&nbsp;<strong>៦.ការអនុញ្ញាត/ មិនអនុញ្ញាត របស់ប្រធានអង្គភាព : </strong>......................................................................</p>

 <table style="height: 104px; width: 100%;" cellspacing="0" cellpadding="0">
    <tbody>
        <tr style="height: 31.7031px;">
            <td style="height: 31.7031px; width: 64.7541%; text-align: center;">
               ${count_day_request_en > 3 && profileData.org_type > 1
        ? `  <br>
                   
                  <p>
                   <p>លេខ........................</p>
 <p>បានឃើញ និង.........................</p>
                  ថ្ងៃ..................ខែ.............ឆ្នាំ..................ស័ក.ព.ស២៥៦......</p>
                <p>ខេត្ត${profileData.province_name} ថ្ងៃទី................ខែ..............ឆ្នាំ ២០២........</p>
                <p style="  font-family: 'Moul';">&nbsp;ប្រធាន${cleaned_orgname_cover}</p>
                <p style="text-align: center;">&nbsp;<br></p>
                `
        : `  <br/> <p>បានឃើញ និង.........................</p>
                    <p>ថ្ងៃ...................ខែ.............ឆ្នាំ...................ស័ក.ព.ស២៥៦......</p>
                <p>ខេត្ត${profileData.province_name} ថ្ងៃទី................ខែ..............ឆ្នាំ ២០២........</p>
                <p style="  font-family: 'Moul';">&nbsp;ប្រធាន${cleaned_orgname}</p>
                <p style="text-align: center;">&nbsp;<br></p>`
      }
            </td>
            <td style="height: 31.7031px; width: 35.1288%; text-align: left;">
                   ${count_day_request_en > 3 && profileData.org_type > 1
        ? `  
                       <p>បានឃើញ និង..............</p>
                <p>ខេត្ត${profileData.province_name} ថ្ងៃទី.......ខែ............ឆ្នាំ ២០២...</p>
                <p style="  font-family: 'Moul';">&nbsp;ប្រធានការិ.រដ្ឋបាល និងបុគ្គលិក</p>
                <p style="text-align: center;">&nbsp;<br></p>`
        : ""
      }
            </td>
        </tr>

    </tbody>
</table>
<p style="text-align: left;">&nbsp;<br></p>
</body>
   <style>
                body {
                        font-family: 'Content';
                        line-height:1.9;

                }
                p{
                        margin-top:0pt; margin-bottom:0pt; text-align:center;
                }
                  table > tbody > tr > td > p > strong {
                  font-size:9pt;
                  }
                  table > tbody  > tr > td {
                  font-size:9pt;
                  }
          @page {
            size: A4;
            margin: 15mm 15mm 10mm 20mm; /* top, right, bottom, left */
          }
        

          /* Add print-specific styles */
          @media print {
            body {
              margin: 0; 
              padding: 0;
              width: 100%;
              height: auto;
              font-size: 11pt;
            }
            p, table > tbody > tr > td {
              font-size: 11pt;
            }
            [style*="Moul"] {
              font-size: 12pt;            }
          }
            .headerstyle p {
             position: relative;
              font-family: 'Content';
            }
             .headerstyle img {
              position: absolute;
              top: 35px;
              }
              .page-break {
              page-break-after: always;
              margin-left
            }
        </style>

      

</html>
       `;

    return <div dangerouslySetInnerHTML={{ __html: htmlContent }} />;
  }
}
